// src/data/static.js
// All large static datasets live here — never inside component files.
// Import only what you need: import { ZONES, GAS_BY_ZONE } from '@data/static'

// ── Zones ─────────────────────────────────────────────────────────
export const ZONES = [
  'N.O. East',
  'Lakeview',
  'Gentilly',
  'Lower 9th Ward',
  'Carrollton',
  'Uptown',
  'Mid-City',
  'French Quarter',
  'Algiers',
  'Northshore / Slidell',
];

// ── Gas stations by zone ──────────────────────────────────────────
export const GAS_BY_ZONE = {
  'N.O. East': [
    { id: 'g1', name: 'Shell - Chef Menteur Hwy', address: '6801 Chef Menteur Hwy', status: 'open',   price: '$3.49', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 8, lat: 30.016, lon: -89.965 },
    { id: 'g2', name: 'Circle K - Read Blvd',     address: '6000 Read Blvd',        status: 'open',   price: '$3.52', wait: '~10 min', fuel: 'Regular only',    updatedMins: 22, lat: 30.012, lon: -89.971 },
    { id: 'g3', name: 'Chevron - Morrison Rd',    address: '5501 Morrison Rd',      status: 'busy',   price: '$3.55', wait: '~30 min', fuel: 'Regular/Diesel',  updatedMins: 35, lat: 30.019, lon: -89.952 },
    { id: 'g4', name: 'Exxon - Chef Menteur',     address: '4400 Chef Menteur Hwy', status: 'closed', price: null,    wait: 'Closed',  fuel: null,              updatedMins: 60, lat: 30.013, lon: -89.978 },
    { id: 'g5', name: 'BP - Bullard Ave',          address: '10001 Bullard Ave',     status: 'open',   price: '$3.47', wait: 'No wait', fuel: 'All grades',      updatedMins: 15, lat: 30.021, lon: -89.945 },
  ],
  'Lakeview': [
    { id: 'g6', name: 'Shell - Metairie Rd',   address: '3200 Metairie Rd',  status: 'open',   price: '$3.51', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 12, lat: 29.998, lon: -90.114 },
    { id: 'g7', name: 'Circle K - Canal Blvd', address: '5100 Canal Blvd',   status: 'busy',   price: '$3.48', wait: '~20 min',  fuel: 'Regular only',    updatedMins: 18, lat: 29.995, lon: -90.108 },
    { id: 'g8', name: 'Chevron - West End Blvd',address: '7000 West End Blvd',status: 'closed', price: null,    wait: 'Closed',   fuel: null,              updatedMins: 120, lat: 30.001, lon: -90.118 },
  ],
  'Gentilly': [
    { id: 'g9',  name: 'BP - Gentilly Blvd',      address: '4800 Gentilly Blvd',    status: 'busy', price: '$3.53', wait: '~25 min', fuel: 'Regular/Diesel', updatedMins: 5, lat: 30.007, lon: -90.047 },
    { id: 'g10', name: 'Shell - St. Bernard Ave',  address: '3100 St. Bernard Ave',  status: 'open', price: '$3.50', wait: 'No wait', fuel: 'All grades',     updatedMins: 30, lat: 30.003, lon: -90.052 },
    { id: 'g11', name: 'Exxon - Paris Ave',        address: '2900 Paris Ave',        status: 'closed',price: null,   wait: 'Closed', fuel: null,              updatedMins: 180, lat: 30.01, lon: -90.044 },
  ],
  'Lower 9th Ward': [
    { id: 'g12', name: 'BP - St. Claude Ave',      address: '4200 St. Claude Ave',   status: 'closed', price: null, wait: 'Closed', fuel: null, updatedMins: 240, lat: 29.97, lon: -89.996 },
    { id: 'g13', name: 'Shell - Claiborne Ave',    address: '3800 N. Claiborne Ave', status: 'closed', price: null, wait: 'Closed', fuel: null, updatedMins: 240, lat: 29.968, lon: -90.001 },
  ],
  'Carrollton': [
    { id: 'g14', name: 'Shell - S. Carrollton Ave', address: '3100 S. Carrollton Ave', status: 'open', price: '$3.46', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 6, lat: 29.944, lon: -90.135 },
    { id: 'g15', name: 'Circle K - Airline Hwy',    address: '2700 Airline Hwy',       status: 'open', price: '$3.44', wait: '~5 min', fuel: 'Regular only',     updatedMins: 14, lat: 29.948, lon: -90.128 },
    { id: 'g16', name: 'Chevron - Tulane Ave',       address: '2200 Tulane Ave',        status: 'busy', price: '$3.50', wait: '~15 min',fuel: 'All grades',        updatedMins: 40, lat: 29.951, lon: -90.121 },
  ],
  'Uptown': [
    { id: 'g17', name: 'Shell - Magazine St',        address: '5600 Magazine St',        status: 'open', price: '$3.52', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 9, lat: 29.928, lon: -90.096 },
    { id: 'g18', name: 'BP - Napoleon Ave',           address: '3500 Napoleon Ave',       status: 'open', price: '$3.49', wait: 'No wait',  fuel: 'Regular/Diesel',  updatedMins: 20, lat: 29.925, lon: -90.089 },
    { id: 'g19', name: 'Exxon - Tchoupitoulas',      address: '7000 Tchoupitoulas St',   status: 'busy', price: '$3.54', wait: '~20 min', fuel: 'Regular only',     updatedMins: 45, lat: 29.932, lon: -90.101 },
  ],
  'Mid-City': [
    { id: 'g20', name: 'Shell - Canal St',          address: '4200 Canal St',           status: 'open', price: '$3.48', wait: 'No wait',  fuel: 'All grades',      updatedMins: 3, lat: 29.983, lon: -90.087 },
    { id: 'g21', name: 'Circle K - Broad Ave',      address: '3100 Broad Ave',          status: 'busy', price: '$3.51', wait: '~15 min', fuel: 'Regular only',     updatedMins: 25, lat: 29.979, lon: -90.082 },
    { id: 'g22', name: 'Chevron - Jeff Davis Pkwy', address: '3600 Jeff Davis Pkwy',    status: 'open', price: '$3.47', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 17, lat: 29.986, lon: -90.091 },
  ],
  'French Quarter': [
    { id: 'g23', name: 'Exxon - N. Rampart St',    address: '1400 N. Rampart St',      status: 'open', price: '$3.58', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 11, lat: 29.958, lon: -90.064 },
    { id: 'g24', name: 'Shell - Elysian Fields',   address: '700 Elysian Fields Ave',  status: 'busy', price: '$3.55', wait: '~10 min',fuel: 'Regular only',    updatedMins: 28, lat: 29.955, lon: -90.06 },
  ],
  'Algiers': [
    { id: 'g25', name: 'BP - General De Gaulle',   address: '3200 General De Gaulle',  status: 'open', price: '$3.46', wait: 'No wait',  fuel: 'All grades',      updatedMins: 7, lat: 29.928, lon: -90.035 },
    { id: 'g26', name: 'Shell - Manhattan Blvd',   address: '1800 Manhattan Blvd',     status: 'open', price: '$3.48', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 19, lat: 29.924, lon: -90.041 },
    { id: 'g27', name: 'Circle K - Lapalco Blvd',  address: '4400 Lapalco Blvd',       status: 'busy', price: '$3.50', wait: '~20 min', fuel: 'Regular only',    updatedMins: 42, lat: 29.92, lon: -90.038 },
  ],

  'Jefferson Parish': [
    { id: 'g40', name: 'Shell - Westbank Expwy', address: '1400 Westbank Expwy, Gretna', status: 'open', price: '$3.46', wait: 'No wait', fuel: 'All grades', updatedMins: 10, lat: 29.917, lon: -90.054 },
    { id: 'g41', name: 'Circle K - Barataria Blvd', address: '2800 Barataria Blvd, Marrero', status: 'open', price: '$3.44', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 22, lat: 29.895, lon: -90.098 },
    { id: 'g42', name: 'BP - Stumpf Blvd', address: '1100 Stumpf Blvd, Gretna', status: 'open', price: '$3.45', wait: 'No wait', fuel: 'Regular only', updatedMins: 18, lat: 29.91, lon: -90.07 },
  ],
  'Metairie': [
    { id: 'g44', name: 'Shell - Veterans Blvd', address: '3900 Veterans Blvd, Metairie', status: 'open', price: '$3.47', wait: 'No wait', fuel: 'All grades', updatedMins: 8, lat: 29.991, lon: -90.188 },
    { id: 'g45', name: 'Circle K - Causeway Blvd', address: '3300 Causeway Blvd, Metairie', status: 'open', price: '$3.45', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 14, lat: 29.988, lon: -90.175 },
    { id: 'g46', name: 'Exxon - Airline Dr', address: '6800 Airline Dr, Metairie', status: 'busy', price: '$3.50', wait: '~20 min', fuel: 'Regular/Diesel', updatedMins: 30, lat: 29.985, lon: -90.182 },
  ],
  'Kenner': [
    { id: 'g48', name: 'Shell - Williams Blvd', address: '3200 Williams Blvd, Kenner', status: 'open', price: '$3.44', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 6, lat: 29.994, lon: -90.244 },
    { id: 'g49', name: 'Circle K - W. Esplanade Ave', address: '2900 W. Esplanade Ave, Kenner', status: 'open', price: '$3.42', wait: 'No wait', fuel: 'Regular only', updatedMins: 19, lat: 29.991, lon: -90.238 },
  ],
  'St. Bernard Parish': [
    { id: 'g51', name: 'Shell - St. Bernard Hwy', address: '8600 St. Bernard Hwy, Chalmette', status: 'open', price: '$3.45', wait: 'No wait', fuel: 'All grades', updatedMins: 9, lat: 29.937, lon: -89.974 },
    { id: 'g52', name: 'Circle K - Paris Rd', address: '4100 Paris Rd, Chalmette', status: 'open', price: '$3.43', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 21, lat: 29.933, lon: -89.968 },
    { id: 'g53', name: 'BP - Judge Perez Dr', address: '2700 Judge Perez Dr, Chalmette', status: 'busy', price: '$3.47', wait: '~15 min', fuel: 'Regular/Diesel', updatedMins: 40, lat: 29.94, lon: -89.98 },
  ],
  'St. Tammany Parish': [
    { id: 'g54', name: 'Shell - Hwy 190, Covington', address: '1200 Hwy 190, Covington', status: 'open', price: '$3.42', wait: 'No wait', fuel: 'All grades', updatedMins: 7, lat: 30.476, lon: -90.101 },
    { id: 'g55', name: 'Circle K - Hwy 59, Mandeville', address: '3300 Hwy 59, Mandeville', status: 'open', price: '$3.40', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 15, lat: 30.358, lon: -90.068 },
  ],
  'Plaquemines Parish': [
    { id: 'g57', name: 'Shell - Hwy 23, Belle Chasse', address: '8500 Hwy 23, Belle Chasse', status: 'open', price: '$3.44', wait: 'No wait', fuel: 'All grades', updatedMins: 11, lat: 29.845, lon: -89.988 },
    { id: 'g58', name: 'BP - Hwy 23, Port Sulphur', address: '23300 Hwy 23, Port Sulphur', status: 'open', price: '$3.42', wait: 'No wait', fuel: 'Regular/Diesel', updatedMins: 35, lat: 29.42, lon: -89.82 },
  ],
  'St. Charles Parish': [
    { id: 'g60', name: 'Shell - Hwy 90, Boutte', address: '13600 Hwy 90, Boutte', status: 'open', price: '$3.43', wait: 'No wait', fuel: 'All grades', updatedMins: 8, lat: 29.898, lon: -90.38 },
    { id: 'g61', name: 'Circle K - Airline Hwy, Norco', address: '11200 Airline Hwy, Norco', status: 'open', price: '$3.41', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 20, lat: 29.975, lon: -90.394 },
  ],
  'St. John Parish': [
    { id: 'g63', name: 'Shell - Hwy 51, LaPlace', address: '1400 Hwy 51, LaPlace', status: 'open', price: '$3.42', wait: 'No wait', fuel: 'All grades', updatedMins: 6, lat: 30.071, lon: -90.482 },
    { id: 'g64', name: 'Circle K - Airline Hwy, LaPlace', address: '2200 Airline Hwy, LaPlace', status: 'open', price: '$3.40', wait: 'No wait', fuel: 'Regular/Premium', updatedMins: 17, lat: 30.068, lon: -90.487 },
  ],
  'Northshore / Slidell': [
    { id: 'g28', name: 'Shell - Fremaux Ave',       address: '1500 Fremaux Ave',        status: 'open', price: '$3.43', wait: 'No wait',  fuel: 'All grades',      updatedMins: 4, lat: 30.286, lon: -89.781 },
    { id: 'g29', name: 'Circle K - Gause Blvd',    address: '3200 Gause Blvd',         status: 'open', price: '$3.41', wait: 'No wait',  fuel: 'Regular/Premium', updatedMins: 16, lat: 30.281, lon: -89.775 },
    { id: 'g30', name: 'Chevron - US-190',           address: '900 US-190, Slidell',     status: 'busy', price: '$3.45', wait: '~15 min', fuel: 'Regular/Diesel',  updatedMins: 33, lat: 30.275, lon: -89.785 },
    { id: 'g31', name: 'BP - Old Spanish Trail',    address: '2100 Old Spanish Trail',  status: 'open', price: '$3.42', wait: 'No wait',  fuel: 'All grades',      updatedMins: 21, lat: 30.29, lon: -89.778 },
  ],
};

export function getGasForZone(zone) {
  return GAS_BY_ZONE[zone] ?? GAS_BY_ZONE['N.O. East'];
}

// ── Emergency contacts ────────────────────────────────────────────
export const CONTACTS = [
  {
    group: 'Emergency',
    items: [
      { name: 'Emergency (Police/Fire/EMS)', phone: '911',          urgent: true },
      { name: 'Non-Emergency Police',        phone: '5046581000'                 },
      { name: 'Entergy Outages',             phone: '18004393932'                },
      { name: 'Sewerage & Water Board',      phone: '5045295262'                 },
    ],
  },
  {
    group: 'Shelters & Relief',
    items: [
      { name: 'Red Cross Louisiana',         phone: '18004733767'                },
      { name: 'Salvation Army Louisiana',    phone: '18004753120'                },
      { name: 'FEMA Helpline',               phone: '18006213362'                },
      { name: 'LA GOHSEP',                   phone: '2257237700'                 },
    ],
  },
  {
    group: 'Medical',
    items: [
      { name: 'Tulane Medical Center ER',    phone: '5049885263'                 },
      { name: 'UMC New Orleans ER',          phone: '5049031000'                 },
      { name: 'Poison Control Center',       phone: '18002221222'                },
    ],
  },
  {
    group: 'Transportation',
    items: [
      { name: 'DOTD Road Conditions (511)', phone: '511'                         },
      { name: 'Jefferson Transit',           phone: '5043645555'                 },
      { name: 'RTA New Orleans',             phone: '5042482175'                 },
    ],
  },
];

// ── Evacuation routes ─────────────────────────────────────────────
export const EVAC_ROUTES = [
  {
    id: 'i10w',
    name: 'I-10 West (Primary)',
    direction: 'West to Baton Rouge / Lafayette',
    status: 'open',
    note: 'Primary evacuation route. Contraflow may be active. Monitor 511.',
    exits: ['Causeway Blvd', 'Kenner', 'Metairie Rd', 'Williams Blvd'],
    link: null, // resolved from DOTD.publicUrl in config.js
  },
  {
    id: 'i10e',
    name: 'I-10 East (Contraflow)',
    direction: 'East to Slidell / Mississippi',
    status: 'open',
    note: 'Contraflow activated during major evacuations. All lanes outbound.',
    exits: ['Chef Menteur', 'Michoud', 'Slidell', 'MS State Line'],
    link: null, // resolved from DOTD.publicUrl in config.js
  },
  {
    id: 'us90',
    name: 'US-90 Westbank',
    direction: 'West via Westbank',
    status: 'open',
    note: 'Use Crescent City Connection or Greater NO Bridge to access.',
    exits: ['Algiers', 'Gretna', 'Harvey', 'Westwego'],
    link: null, // resolved from DOTD.publicUrl in config.js
  },
  {
    id: 'la23',
    name: 'LA-23 South (Avoid during surge)',
    direction: 'South to Belle Chasse / Port Sulphur',
    status: 'caution',
    note: 'Low elevation. Close during surge events. Monitor NWS alerts.',
    exits: ['Belle Chasse', 'Venice', 'Boothville'],
    link: null, // resolved from DOTD.publicUrl in config.js
  },
  {
    id: 'i55',
    name: 'I-55 North',
    direction: 'North via Manchac / Hammond',
    status: 'open',
    note: 'Alternative to I-10 West. Less traffic during early evacuations.',
    exits: ['LaPlace', 'Ponchatoula', 'Hammond'],
    link: null, // resolved from DOTD.publicUrl in config.js
  },
];

// ── Key road corridors for traffic page ──────────────────────────
export const TRAFFIC_CORRIDORS = [
  { id: 'i10w',     name: 'I-10 West',              type: 'evac',   floodRisk: 'low',      note: 'Primary evacuation. Keep moving west.' },
  { id: 'i10e',     name: 'I-10 East',              type: 'evac',   floodRisk: 'low',      note: 'Contraflow active during major events.' },
  { id: 'i610',     name: 'I-610 Inner Loop',       type: 'evac',   floodRisk: 'low',      note: 'Connects I-10 corridors through the city.' },
  { id: 'us90',     name: 'US-90 Westbank',         type: 'evac',   floodRisk: 'low',      note: 'Westbank primary evacuation route.' },
  { id: 'la23',     name: 'LA-23 South',            type: 'evac',   floodRisk: 'moderate', note: 'Monitor for surge south of Belle Chasse.' },
  { id: 'causeway', name: 'Lake Pontchartrain Causeway', type: 'bridge', floodRisk: 'high', note: 'Closes at winds over 30mph or surge warnings.' },
  { id: 'ccc',      name: 'Crescent City Connection', type: 'bridge', floodRisk: 'low',   note: 'Bridge to Westbank. Usually open.' },
  { id: 'chefpass', name: 'Chef Pass at Hayne Blvd', type: 'local', floodRisk: 'extreme', note: 'Closes at 1 inch of rain. Avoid during any storm.' },
  { id: 'elysian',  name: 'Elysian Fields Underpass', type: 'local', floodRisk: 'high',   note: 'Underpass floods rapidly. Do not use in storms.' },
  { id: 'gentilly', name: 'Gentilly Blvd at Filmore', type: 'local', floodRisk: 'high',   note: 'Low-lying. Floods before adjacent streets.' },
  { id: 'morrison', name: 'Morrison Rd (N.O. East)', type: 'local', floodRisk: 'moderate',note: 'Alternate to Chef Pass. Open longer.' },
];

// ── Low-water crossings for gauge inference ───────────────────────
export const LOW_WATER_CROSSINGS = [
  { id: 'lw1', name: 'Hayne Blvd at Chef Pass',      gaugeId: '07374525', closureStage: 1.5, lat: 30.035, lon: -89.952 },
  { id: 'lw2', name: 'Filmore Ave at Gentilly Blvd', gaugeId: '07374000', closureStage: 3.0, lat: 30.002, lon: -90.063 },
  { id: 'lw3', name: 'Paris Ave at Mirabeau',         gaugeId: '07374000', closureStage: 4.0, lat: 30.005, lon: -90.052 },
  { id: 'lw4', name: 'Elysian Fields Underpass',      gaugeId: '07374525', closureStage: 0.5, lat: 30.000, lon: -90.031 },
];

// ── Radio stations ────────────────────────────────────────────────
export const RADIO_STATIONS = [
  { id: 'wwl',  name: 'WWL 870 AM',      freq: '870 AM',    desc: 'Primary emergency station for New Orleans',      stream: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WWL_AM.mp3' },
  { id: 'wdsu', name: 'WDSU News Radio', freq: '105.3 FM',  desc: 'Breaking news and weather',                      stream: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WDSUFMAAC.aac' },
  { id: 'wrno', name: 'WRNO 99.5 FM',    freq: '99.5 FM',   desc: 'Local news and emergency updates',               stream: null },
  { id: 'wbok', name: 'WBOK 1230 AM',    freq: '1230 AM',   desc: 'Community focused coverage',                     stream: null },
  { id: 'nws',  name: 'NWS Weather Radio', freq: 'WXL-48', desc: 'NOAA weather radio - continuous broadcast',       stream: 'https://www.weather.gov/audio/NWR.mp3' },
  { id: 'fema', name: 'FEMA EAS',         freq: 'EAS',      desc: 'Emergency Alert System broadcasts',              stream: null },
];

// ── Safety guides ─────────────────────────────────────────────────
export const GUIDES = [
  {
    id: 'hurricane',
    title: 'Hurricane Preparation',
    icon: '🌀',
    category: 'Prepare',
    steps: [
      { title: 'Know your zone', content: 'Check your evacuation zone at ready.nola.gov. Zones A and B evacuate first during major storms.' },
      { title: 'Stock supplies', content: 'Prepare 72 hours of water (1 gallon per person per day), non-perishable food, medications, flashlights, batteries, and a battery-powered radio.' },
      { title: 'Secure your home', content: 'Board windows, bring in outdoor furniture, secure garage doors, and turn your refrigerator to its coldest setting.' },
      { title: 'Protect documents', content: 'Photograph and backup insurance policies, IDs, and financial documents. Store copies in waterproof container or cloud storage.' },
      { title: 'Plan evacuation', content: 'Know at least two evacuation routes. Identify a meeting point for family members. Arrange transportation early if needed.' },
      { title: 'Fill prescriptions', content: 'Get a 30-day supply of all medications. Pack medical equipment (CPAP, insulin cooler, etc.).' },
    ],
  },
  {
    id: 'flood',
    title: 'Flood Safety',
    icon: '🌊',
    category: 'During',
    steps: [
      { title: 'Turn around, do not drown', content: '6 inches of moving water can knock you down. 2 feet of water will float a car. Never drive through flooded roads.' },
      { title: 'Move to higher ground', content: 'If flooding is imminent, move to the highest floor of your building. Do not go into attics unless you have a way out through the roof.' },
      { title: 'Avoid flood water', content: 'Flood water may be electrically charged from underground lines. It may contain sewage, chemicals, or sharp debris.' },
      { title: 'Signal for help', content: 'If trapped, signal from a window or roof. Use a flashlight at night. Call 911 if you have service.' },
      { title: 'Shelter in place', content: 'If evacuation is not possible, go to upper floors. Bring water, food, medications, and your phone with a charger.' },
    ],
  },
  {
    id: 'heat',
    title: 'Extreme Heat Safety',
    icon: '☀️',
    category: 'During',
    steps: [
      { title: 'Stay hydrated', content: 'Drink water every 15-20 minutes even if not thirsty. Avoid alcohol and caffeine which dehydrate you faster.' },
      { title: 'Find cooling centers', content: 'During power outages, go to public libraries, community centers, and cooling shelters. Check Eye on Storm feed for open locations.' },
      { title: 'Check on vulnerable neighbors', content: 'Elderly residents, children, and those with medical conditions are at highest risk. Check on them every 2-3 hours during extreme heat.' },
      { title: 'Recognize heat stroke', content: 'Warning signs: high body temp (103F+), hot/red/dry skin, rapid strong pulse, unconsciousness. Call 911 immediately and cool the person.' },
    ],
  },
  {
    id: 'power',
    title: 'Power Outage Guide',
    icon: '⚡',
    category: 'During',
    steps: [
      { title: 'Generator safety', content: 'NEVER run a generator indoors or in a garage. Keep it 20+ feet from windows. Carbon monoxide kills silently and quickly.' },
      { title: 'Food safety', content: 'Refrigerator keeps food safe for 4 hours. Freezer for 48 hours if full. When in doubt, throw it out.' },
      { title: 'Medical equipment', content: 'If you depend on electricity for medical equipment, contact Entergy to register as a critical customer. Call 911 if life-threatening.' },
      { title: 'Conserve phone battery', content: 'Enable airplane mode when possible. Lower brightness. Close unused apps. A car charger works even without home power.' },
      { title: 'Stay informed', content: 'Use a battery-powered radio. Follow WWL 870 AM for Entergy restoration updates and emergency broadcasts.' },
    ],
  },
  {
    id: 'communication',
    title: 'Emergency Communication',
    icon: '📡',
    category: 'Prepare',
    steps: [
      { title: 'Establish a family plan', content: 'Choose an out-of-state contact everyone can reach. Texts often go through when calls do not. Agree on a meeting point.' },
      { title: 'Text vs call', content: 'During disasters, text messages use less network bandwidth and are more likely to get through than voice calls.' },
      { title: 'Social media check-in', content: 'Use Facebook Safety Check, Google Person Finder, or post your status publicly so family can find you.' },
      { title: 'Know your neighbors', content: 'Introduce yourself to at least 5 neighbors. Exchange phone numbers. Agree to check on each other during emergencies.' },
    ],
  },
];

// ── Emergency checklist ───────────────────────────────────────────
export const CHECKLIST = [
  {
    category: 'Water & Food',
    icon: '💧',
    items: [
      { id: 'c1',  text: '1 gallon water per person per day (3-day supply)' },
      { id: 'c2',  text: 'Non-perishable food (3-day supply)' },
      { id: 'c3',  text: 'Manual can opener' },
      { id: 'c4',  text: 'Baby formula/food if needed' },
    ],
  },
  {
    category: 'Communication',
    icon: '📻',
    items: [
      { id: 'c5',  text: 'Battery-powered or hand-crank radio' },
      { id: 'c6',  text: 'Portable phone charger (fully charged)' },
      { id: 'c7',  text: 'List of emergency contacts (printed)' },
      { id: 'c8',  text: 'Whistle to signal for help' },
    ],
  },
  {
    category: 'Medical',
    icon: '🏥',
    items: [
      { id: 'c9',  text: '30-day supply of prescription medications' },
      { id: 'c10', text: 'First aid kit' },
      { id: 'c11', text: 'Copies of medical records/prescriptions' },
      { id: 'c12', text: 'Glasses/contacts and supplies' },
    ],
  },
  {
    category: 'Documents',
    icon: '📄',
    items: [
      { id: 'c13', text: 'Government-issued ID (copy + original)' },
      { id: 'c14', text: 'Insurance documents (home, vehicle, health)' },
      { id: 'c15', text: 'Bank account information' },
      { id: 'c16', text: 'Deed/lease agreement copy' },
    ],
  },
  {
    category: 'Safety & Tools',
    icon: '🔦',
    items: [
      { id: 'c17', text: 'Flashlight + extra batteries' },
      { id: 'c18', text: 'N95 masks (minimum 5 per person)' },
      { id: 'c19', text: 'Rain gear and warm clothing' },
      { id: 'c20', text: 'Work gloves and sturdy shoes' },
    ],
  },
  {
    category: 'Pets & Family',
    icon: '🐾',
    items: [
      { id: 'c21', text: 'Pet food, water, and carrier' },
      { id: 'c22', text: 'Pet vaccination records' },
      { id: 'c23', text: 'Children\'s supplies (diapers, formula, games)' },
      { id: 'c24', text: 'Cash in small bills (ATMs may be down)' },
    ],
  },
];

// CORS_PROXIES and USGS_GAUGES moved to src/config.js
// Import them from '@config' instead of here.
